let videos: HTMLVideoElement[] = [];

function onMouseenter(this: HTMLElement) {
    const video = this.querySelector<HTMLVideoElement>('video.js-main-advantage-video');
    video?.play();
}

function onMouseleave(this: HTMLElement) {
    const video = this.querySelector<HTMLVideoElement>('video.js-main-advantage-video');
    video?.pause();
}

function onResize() {
    const isTouch = matchMedia('(hover: none)').matches;
    videos.forEach((video) => {
        video.autoplay = isTouch;
    });
}

function init(container: Element | Document = document) {
    Array.from(container.querySelectorAll<HTMLElement>('.js-main-advantage')).forEach((el) => {
        el.addEventListener('mouseenter', onMouseenter);
        el.addEventListener('mouseleave', onMouseleave);
    });

    videos = Array.from(container.querySelectorAll<HTMLVideoElement>('video.js-main-advantage-video'));
    onResize();
    window.addEventListener('resize', onResize);
}

function destroy(container: Element | Document = document) {
    window.removeEventListener('resize', onResize);

    Array.from(container.querySelectorAll<HTMLElement>('.js-main-advantage')).forEach((el) => {
        el.removeEventListener('mouseenter', onMouseenter);
        el.removeEventListener('mouseleave', onMouseleave);
    });
}

const module = { init, destroy };

export default module;
